import { OwnerRowValue } from 'src/financial/financial-data/financial-item/forms/common/OwnersEditor';

/**
 * The client a new item is created through. The backend refuses a new item whose owners leave
 * out that client, so where they do, it is created through the first family member among the
 * owners instead, or the first client owner if none is in the family: owners can come from
 * outside the family, but the item is added from this family's screens.
 */
export function newItemHolderId(
  owners: OwnerRowValue[],
  startingClientId: string,
  memberClientIds: Set<string>,
): string {
  const ownerIds = owners.flatMap(owner => (owner.client_id ? [owner.client_id] : []));
  if (ownerIds.length === 0 || ownerIds.includes(startingClientId)) return startingClientId;
  return ownerIds.find(ownerId => memberClientIds.has(ownerId)) ?? ownerIds[0];
}
